export function simpleTransformer(response) {
  return response
}
